export default {
  data() {
    return {
      isOpenCardDetails: false,
      isOpenAddCard: false,
    }
  },
  methods: {
    openCardDetails() {
      this.isOpenCardDetails = true;
    },
    closeCardDetails() {
      this.isOpenCardDetails = false;
    },
    openAddCard() {
      this.closeCardDetails();
      this.isOpenAddCard = true;
    },
    closeAddCard() {
      this.isOpenAddCard = false;
      this.getReservation();
    },
  }
}
